<header>
	<div class="container">
		<div class="bh-logo">
			<ea-bh-logo></ea-bh-logo>
			<h1
				class="title"
				[innerHTML]="productName"
				data-cy="product-name-title-text"
			></h1>
			@if (isInternalAdmin) {
				<span class="pipe">&nbsp;</span>
			}
			@if (isInternalAdmin) {
				<span
					class="app-environment-span app-environment-{{
						environmentName | lowercase
					}}"
					data-cy="ia-environment-text"
					>{{ environmentName }}</span
				>
			}
		</div>
		<ng-content></ng-content>
	</div>
</header>
